import { Controller } from "@hotwired/stimulus"

// Inline sign-up form checks that don't need a full submit round-trip:
// - email availability, checked against the server on blur (an account may
//   already exist for that address)
// - password/confirmation match, checked purely client-side on blur
export default class extends Controller {
  static targets = ["email", "password", "confirmation"]
  static values = { checkUrl: String, loginUrl: String }

  async checkEmail() {
    const email = this.emailTarget.value.trim()

    if (!email) {
      this.clearError(this.emailTarget)
      return
    }

    const url = new URL(this.checkUrlValue, window.location.origin)
    url.searchParams.set("email", email)

    let json
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      json = await response.json()
    } catch (error) {
      return
    }

    if (json.taken) {
      this.showError(this.emailTarget, `You already have an account &mdash; <a href="${this.loginUrlValue}">Log in</a>`)
    } else {
      this.clearError(this.emailTarget)
    }
  }

  checkPasswordMatch() {
    const confirmation = this.confirmationTarget.value

    if (!confirmation) {
      this.clearError(this.confirmationTarget)
      return
    }

    if (this.passwordTarget.value === confirmation) {
      this.clearError(this.confirmationTarget)
    } else {
      this.showError(this.confirmationTarget, "doesn't match Password")
    }
  }

  showError(input, html) {
    input.classList.add("is-invalid")

    let feedback = this.feedbackElement(input)
    if (!feedback) {
      feedback = document.createElement("span")
      feedback.className = "invalid-feedback d-block"
      feedback.setAttribute("data-feedback-for", input.id)
      input.closest(".form-floating").appendChild(feedback)
    }

    feedback.innerHTML = html
  }

  clearError(input) {
    input.classList.remove("is-invalid")
    this.feedbackElement(input)?.remove()
  }

  feedbackElement(input) {
    return this.element.querySelector(`[data-feedback-for="${input.id}"]`)
  }
}
